
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|2746|718|868)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
